(function () {
  var STORAGE_KEY = 'rizutek:recently-viewed';
  var MAX_STORED = 12;

  function getStored() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function setStored(handles) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(handles));
    } catch (e) {
      /* storage unavailable (private mode, etc.) — fail silently */
    }
  }

  function recordCurrentProduct(handle) {
    if (!handle) return;
    var handles = getStored().filter(function (h) {
      return h !== handle;
    });
    handles.unshift(handle);
    setStored(handles.slice(0, MAX_STORED));
  }

  function formatYen(amountInCents) {
    var yen = Math.round(amountInCents / 100);
    return '¥' + yen.toLocaleString('ja-JP');
  }

  function buildCard(product) {
    var variant = product.variants && product.variants[0];
    var image = product.featured_image || (product.images && product.images[0]);
    var price = variant ? variant.price : product.price;
    var compareAtPrice = variant ? variant.compare_at_price : null;

    var a = document.createElement('a');
    a.href = product.url;
    a.className = 'recently-viewed__card';

    var imgWrap = document.createElement('div');
    imgWrap.className = 'recently-viewed__image-wrap';
    if (image) {
      var img = document.createElement('img');
      img.src = image;
      img.alt = product.title;
      img.loading = 'lazy';
      imgWrap.appendChild(img);
    }
    a.appendChild(imgWrap);

    var title = document.createElement('span');
    title.className = 'recently-viewed__title';
    title.textContent = product.title;
    a.appendChild(title);

    var priceWrap = document.createElement('span');
    priceWrap.className = 'recently-viewed__price';
    if (compareAtPrice && compareAtPrice > price) {
      var was = document.createElement('s');
      was.className = 'recently-viewed__compare-price';
      was.textContent = formatYen(compareAtPrice);
      priceWrap.appendChild(was);
      priceWrap.appendChild(document.createTextNode(' '));
    }
    priceWrap.appendChild(document.createTextNode(formatYen(price)));
    a.appendChild(priceWrap);

    return a;
  }

  function renderSection(el) {
    var currentHandle = el.getAttribute('data-current-handle');
    recordCurrentProduct(currentHandle);

    var handles = getStored()
      .filter(function (h) {
        return h !== currentHandle;
      })
      .slice(0, parseInt(el.getAttribute('data-max-products'), 10) || 6);

    if (handles.length === 0) {
      el.remove();
      return;
    }

    var list = el.querySelector('[data-recently-viewed-list]');

    Promise.all(
      handles.map(function (handle) {
        return fetch('/products/' + handle + '.js')
          .then(function (res) {
            return res.ok ? res.json() : null;
          })
          .catch(function () {
            return null;
          });
      })
    ).then(function (products) {
      var valid = products.filter(Boolean);
      if (valid.length === 0) {
        el.remove();
        return;
      }
      valid.forEach(function (product) {
        list.appendChild(buildCard(product));
      });
      el.classList.remove('recently-viewed--loading');
    });
  }

  function init() {
    document.querySelectorAll('[data-recently-viewed]').forEach(renderSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
